// @ts-nocheck
// @ts-ignore

import {useState, useEffect} from "react";
import {useConsentStore} from "../store/consent-store";
import Cookies from "js-cookie";

export const useSendForm = () => {
  const consent = useConsentStore((state) => state.consent);

  const [isPending, setPending] = useState(false);
  const [error, setError] = useState(false);

  const getYandexClientId = () => {
    if (!consent) return;
    window.site = {};
    site.clientID = 0;
    try {
      setTimeout(() => {
        let metriks = parseInt(
          Object.keys(window.Ya._metrika.counters)[0].split(":")[0],
        );
        ym(metriks, "getClientID", function (clientID) {
          site.clientID = clientID;
          console.log("yandex client id = " + clientID);
        });
      }, 7000);
    } catch (e) {
      console.log("error getting yandex client id");
    }
  };

  useEffect(() => {
    if (consent) {
      getYandexClientId();
    }
  }, [consent]);

  const getUtms = (paths: string) => {
    let utm = {};
    if (paths.split("&").length > 0) {
      let params: string[] = paths.split("&");
      params.forEach((param) => {
        param = param.split("=");
        if (
          param[0] === "utm_medium" ||
          param[0] === "utm_content" ||
          param[0] === "utm_campaign" ||
          param[0] === "utm_term" ||
          param[0] === "utm_source"
        ) {
          utm = {...utm, [param[0]]: param[1]};
        }
      });
    }
    return utm;
  };

  const getParam = (p) => {
    var match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
  };

  const showAlert = (senddata: any, celtype: string, sendCell) => {
    if (window.Ya !== undefined && sendCell) {
      let metriks = parseInt(
        Object.keys(window.Ya._metrika.counters)[0].split(":")[0],
      );
      try {
        ym(metriks, "reachGoal", celtype);
        ym(metriks, "reachGoal", "vse");
      } catch (e) {
      }
    }


    fetch("fd_log/lrcnt_react.php", {})
      .then((data) => data.ok && data.json())
      .then((response) => {
        data = {...data, ...response};
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify(data),
        };
        fetch("main/ajax.php", requestOptions).then((data) => data.ok);
      });
  };

  const sendForm = (data: any, celtype: string, callback: () => void) => {
    setPending(true)

    let url = window.location.toString().split("?");

    let utm = null;
    if (url.length > 1) {
      utm = getUtms(url[1]);
    }

    let senddata;

    if (consent) {
      senddata = {
        getCall: "Y",
        celtype: celtype,
        name: data.name,
        phone: data.phone,
        text: data.text,
        yclid: getParam("yclid"),
        gclid: getParam("gclid"),
        yandexClientId: site.clientID,
        roistat: Cookies.get("roistat_visit"),
        ...utm,
      };
    } else {
      senddata = {
        celtype: celtype,
        name: data.name,
        phone: data.phone,
        text: data.text,
      };
    }

    if (data.email !== undefined) {
      senddata = {...senddata, email: data.email};
    }
    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(senddata),
    };

    callback();
    console.log(senddata);

    fetch("https://integrat.leadactiv.ru/lead/site", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        showAlert(senddata, celtype, !data.repeat);
      }).catch((error) => setError(true))
      .finally(() => setPending(false));

  };

  return {sendForm, isPending, error}
}